import { BACKEND_URL } from '../variables.js'
async function saveView(pageNumber,filterName, request) {
  var response = null;

  try {
    await $.post(`${BACKEND_URL}api/user_attributes/${filterName}/${pageNumber}/save`, JSON.stringify(request)
    , (data, status) => {
      response = data
    });
  } catch (error) {
      console.error('Error saving user attributes:', error)
  }

  return response
}

async function loadView(pageNumber,filterName) {
  var response = null;

    try {
        const data = await $.get(`${BACKEND_URL}api/user_attributes/${filterName}/${pageNumber}/load`);

        if (!data) return null;

        let parsedData = data;
        if (typeof data === 'string') {
            const trimmed = data.trim();
            if (trimmed === "" || trimmed === "[]" || trimmed === "{}") {
                return null;
            }
            parsedData = JSON.parse(trimmed);
        }

        if (Array.isArray(parsedData) && parsedData.length === 0) return null;
        if (typeof parsedData === 'object' && Object.keys(parsedData).length === 0) return null;

        response = parsedData;
    } catch (error) {
        console.error('Error loading user attributes:', error);
    }

    return response;

}

export {
  saveView,
  loadView
}
